export default {"src":"/_next/static/media/sparkles.f0af4edc.svg","height":16,"width":16};